<template>
  <div class="flex-shrink">
    <NuxtLink class="btn p-4" :to="props.newsArticle.articleLink">
      <PayloadImage
        class="h-14 w-auto object-contain"
        :image="props.newsArticle.publicationLogo"
        :sizes="{
          default: '256px',
        }"
      />
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import type { NewsArticle } from '#payload/types'

interface NewsArticleCardProps {
  newsArticle: NewsArticle
}

const props = defineProps<NewsArticleCardProps>()
</script>
